import { createAction } from '@reduxjs/toolkit'

import { T_LANGUAGE_CODES } from '~/src/Constants/LANGUAGE'

export const setLanguageAction = createAction<T_LANGUAGE_CODES | undefined>(
  'Language/setLanguage'
)
